export const formFieldRule = Object.freeze({
	Accepted: 1,
	AfterD: 2,
	Alpha: 3,
	AlphaDash: 4,
	AlphaNum: 5,
	BeforeD: 6,
	BetweenXY: 7,
	ConfirmedFAndSameF: 8,
	DifferentF: 9,
	Date: 10,
	In: 11,
	IntegerAndNumeric: 12,
	Ip: 13,
	MaxX: 14,
	MinX: 15,
	NotIn: 16,
	Regex: 17,
	RequiredIf: 18,
	RequiredWith: 19,
	RequiredWithout: 20,
	RequiredWithoutAll: 21,
	Size: 22,
	Url: 23,
	MaxOne: 24,
	MaxOneIf: 25,
	MaxOneUnless: 26,
});
